<template>
  <teleport to="body">
    <!-- ALERT -->
    <div
      v-if="alertState.open"
      class="app-modal-overlay"
      @click.self="closeAlert"
    >
      <div class="app-modal" role="dialog" aria-modal="true">
        <div class="app-modal-message">{{ alertState.message }}</div>

        <div class="app-modal-actions">
          <button class="app-btn primary" @click="closeAlert">
            {{ alertState.okText }}
          </button>
        </div>
      </div>
    </div>

    <!-- CONFIRM -->
    <div
      v-if="confirmState.open"
      class="app-modal-overlay"
      @click.self="resolveConfirm(false)"
    >
      <div class="app-modal" role="dialog" aria-modal="true">
        <div class="app-modal-message">{{ confirmState.message }}</div>

        <div class="app-modal-actions">
          <button class="app-btn secondary" @click="resolveConfirm(false)">
            {{ confirmState.cancelText }}
          </button>
          <button class="app-btn primary" @click="resolveConfirm(true)">
            {{ confirmState.okText }}
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { watch } from "vue";
import { useRouter } from "vue-router";
import { useAppAlert } from "@/composables/useAppAlert";

const router = useRouter();

const {
  pendingRoutePath,
  alertState,
  closeAlert,
  confirmState,
  resolveConfirm,
} = useAppAlert();

// ✅ showAlertAndMove() 지원: alert 닫힐 때 이동
watch(
  () => alertState.open,
  (isOpen, prevOpen) => {
    // prevOpen=true -> isOpen=false 로 바뀌는 순간(닫힘)
    if (prevOpen && !isOpen && pendingRoutePath.value) {
      const path = pendingRoutePath.value;
      pendingRoutePath.value = "";
      router.push(path);
    }
  }
);
</script>

<style>
.app-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
}

.app-modal {
  background: #fff;
  min-width: 320px;
  max-width: 440px;
  padding: 24px 28px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.18s ease-out;
}

.app-modal-message {
  font-size: 15px;
  line-height: 1.5;
  color: #222;
  text-align: left;
  white-space: pre-line;
}

.app-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 22px;
}

.app-btn {
  min-width: 88px;
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.app-btn.primary {
  background: #1677ff;
  color: #fff;
}
.app-btn.primary:hover {
  background: #125edb;
}

.app-btn.secondary {
  background: #f2f4f6;
  color: #333;
}
.app-btn.secondary:hover {
  background: #e5e8eb;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
